<template>
    <div class="page__header">
        <slot></slot>
    </div>
</template>

<script>    
    export default {}
</script>

<style scoped lang="scss">
    @import '../../../scss/layouts/header.scss';
</style>